import { render } from "./create.vue?vue&type=template&id=38027e86&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"

import "./create.vue?vue&type=style&index=0&id=38027e86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38027e86"

export default script